export * from './patentGallery';
